import BankingOperation from '../../Operation'
import TransferForm from '../../Forms/TransferForm'

export default function BankingTransfer ({ requestConfig, onCompleted, ...props }) {
  return (
    <BankingOperation title='Transferir' {...props}>
      {({ availableBalance }) => (
        <TransferForm
          availableBalance={availableBalance}
          requestConfig={requestConfig}
          onCompleted={onCompleted}
        />
      )}
    </BankingOperation>
  )
}
